/** A tiny history-API router: no framework, no dependencies. */
export type Route =
  | { name: 'login' }
  | { name: 'sites' }
  | { name: 'site'; id: string }
  | { name: 'experiment'; id: string }
  | { name: 'results'; id: string }
  | { name: 'shared'; token: string }
  | { name: 'notfound' };

export function match(path: string): Route {
  const p = path.replace(/\/+$/, '') || '/';
  if (p === '/login') return { name: 'login' };
  if (p === '/' || p === '/sites') return { name: 'sites' };
  let m = /^\/sites\/(site_[a-z0-9]{12})$/.exec(p);
  if (m) return { name: 'site', id: m[1]! };
  m = /^\/experiments\/(exp_[a-z0-9]{12})$/.exec(p);
  if (m) return { name: 'experiment', id: m[1]! };
  m = /^\/experiments\/(exp_[a-z0-9]{12})\/results$/.exec(p);
  if (m) return { name: 'results', id: m[1]! };
  m = /^\/r\/([A-Za-z0-9_-]{43})$/.exec(p);
  if (m) return { name: 'shared', token: m[1]! };
  return { name: 'notfound' };
}

const listeners = new Set<() => void>();

export function navigate(path: string, replace = false): void {
  if (location.pathname + location.search === path) return;
  history[replace ? 'replaceState' : 'pushState'](null, '', path);
  listeners.forEach((l) => l());
}

export function onRoute(cb: () => void): () => void {
  listeners.add(cb);
  addEventListener('popstate', cb);
  return () => {
    listeners.delete(cb);
    removeEventListener('popstate', cb);
  };
}

/** Same-origin <a href> clicks navigate without a page load. */
export function interceptLinks(root: HTMLElement): void {
  root.addEventListener('click', (e) => {
    if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey)
      return;
    const a = (e.target as Element).closest('a');
    if (!a || a.target || !a.href.startsWith(location.origin + '/') || a.hasAttribute('download'))
      return;
    e.preventDefault();
    navigate(a.pathname + a.search);
  });
}
